module.exports = __webpack_public_path__ + "static/media/product_20.d63793e7.png";